import HTMLToReact, { Parser as HTMLParser, TProcessingInstruction } from 'html-to-react';

/**
 * CMS may store curly quotes as literal "u201C"/"u201D" or "\u201C"/"\u201D".
 * Replace with actual Unicode characters so they render as curly quotes.
 */
export function normalizeCmsQuoteString(html: string): string {
  if (!html || typeof html !== 'string') return html;
  // Match either \u201C or u201C (RegExp string so \u isn't interpreted as Unicode)
  return html
    .replace(new RegExp('\\\\?u201C', 'g'), '\u201C')
    .replace(new RegExp('\\\\?u201D', 'g'), '\u201D');
}

/**
 * Removes HTML tags from a string, leaving plain text.
 *
 * @param html - The HTML string to strip tags from.
 * @returns The plain text string with HTML tags removed.
 */
export function stripHtmlTags(html: string): string {
  if (!html || typeof html !== 'string') return html;

  const formattedText = html.replace(/<[^>]*>/g, '');

  return formattedText;
}

const htmlToReactParser = new HTMLParser();
const processNodeDefinitions = new HTMLToReact.ProcessNodeDefinitions();

export const parseHtml = (html: string | null | undefined, instructions: TProcessingInstruction[] = []) =>
  htmlToReactParser.parseWithInstructions(html ?? '', () => true, [
    ...instructions,
    {
      shouldProcessNode: (node) => true,
      processNode: processNodeDefinitions.processDefaultNode,
    },
  ]);

export const parseHeading = (html: string | null | undefined) =>
  parseHtml(html, [
    {
      shouldProcessNode: (node: any) => node.tagName === 'p',
      processNode: (node, children) => <span>{children}</span>,
    },
  ]);
